import React, { Component } from 'react';
import SimpleTooltip from '../tooltip/SimpleTooltip';

class Item extends Component {
  render() {
    const { isLocked, tooltipMess } = this.props;
    return (
      <li className="tab-timer__item" onClick={this.props.changeTab}>
        {this.props.isActive ? (
          <SimpleTooltip message={tooltipMess} position="top">
            <a
              href="#"
              onClick={this.props.changeTab}
              className="tab-timer__link active tab-timer__padding"
            >
              {this.props.name}
            </a>
          </SimpleTooltip>
        ) : (
          <SimpleTooltip message={tooltipMess} position="top">
            <a href="#" className="tab-timer__link tab-timer__padding">
              {this.props.name}
              {isLocked && <i className="icon-padlock" />}
            </a>
          </SimpleTooltip>
        )}
      </li>
    );
  }
}

export default Item;
